import type { TableColumnDefinition} from "@fluentui/react-components";
import { createTableColumn, TableCellLayout, useFluent, useScrollbarWidth } from "@fluentui/react-components";
import type {
    RowRenderer
} from '@fluentui-contrib/react-data-grid-react-window';
import {
    DataGridBody,
    DataGrid,
    DataGridRow,
    DataGridHeader,
    DataGridCell,
    DataGridHeaderCell
} from '@fluentui-contrib/react-data-grid-react-window';
import type { EAppId, ISetting, SettingsData } from "../../../../../interfaces";
import { getSettingArrayFromSettingsData, getDisplayValueForSetting } from "../../../../../utilities/ConfigurationData/ConfigurationData";

export interface ISimpleSettingsDataViewProps {
    applicationId?: EAppId;
    settingsData?: SettingsData;
}

const columns: TableColumnDefinition<ISetting>[] = [
    createTableColumn<ISetting>({
        columnId: "settingsName",
        renderCell: (item) => {
            return (
                <TableCellLayout truncate>
                    {item.name}
                </TableCellLayout>
            );
        },
    }),
    createTableColumn<ISetting>({
        columnId: "settingsValue",
        renderCell: (item) => {
            return (
                <TableCellLayout truncate >
                    {getDisplayValueForSetting(item)}
                </TableCellLayout>
            );
        },
    })
];

const renderRow: RowRenderer<ISetting> = ({ item, rowId }, style) => (
    <DataGridRow<ISetting>
        key={rowId} style={style}>
        {({ renderCell }) => (<DataGridCell>{renderCell(item)}</DataGridCell>)}
    </DataGridRow>
);

const GetRowId = (item: ISetting) => { return `${item.key}`; };

export const SimpleSettingsDataView = (props: ISimpleSettingsDataViewProps) => {
    const { settingsData, applicationId } = props;
    const { targetDocument } = useFluent();
    const scrollbarWidth = useScrollbarWidth({ targetDocument });

    const items: ISetting[] = getSettingArrayFromSettingsData(applicationId, settingsData);

    const maxHeight: number = 400;
    const itemSize: number = 50;
    const dataGridHeight = items.length === 0 || itemSize === 0
        ? 0
        : Math.min(items.length * itemSize, maxHeight);

    return (
        <DataGrid
            items={items}
            columns={columns}
            getRowId={GetRowId}>
            <DataGridHeader style={{ paddingRight: scrollbarWidth }}>
                <DataGridRow>
                    {({ renderHeaderCell }) => (
                        <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                    )}
                </DataGridRow>
            </DataGridHeader>
            <DataGridBody<ISetting> itemSize={itemSize} height={dataGridHeight}  >
                {renderRow}
            </DataGridBody>
        </DataGrid>
    );
};
